<template>
    <div class="ctw-h-full ctw-px-4 ctw-overflow-y-scroll ctw-overflow-x-hidden ctw-max-w-full ctw-flex ctw-flex-col-reverse ctw-space-y-2 ctw-space-y-reverse">
            <ErrorMessage />
            <div v-if="answerSuggestions.length && !isThinking" class="ctw-mt-1 ctw-pl-11 ctw-space-y-2 ">
                <div 
                    v-for="answerSuggestion in answerSuggestions"
                    :key="answerSuggestion.id"
                    class="ctw-flex"
                >
                    <button @click="sendMessage(answerSuggestion)" class="cierra-chat-option">
                        {{answerSuggestion}}
                    </button>
                </div>
            </div>
            <ChatMessage v-if="isThinking" :isLoading="isThinking && !tempMessage && !statusMessage" :sender="name" :isBotMessage="true" :avatarUrl="avatarUrl" :text="tempMessage ?? statusMessage" />
            <ChatMessage  v-for="message in messages" :key="message.id" :text="message.text" :sender="message.sender.name" :avatarUrl="avatarUrl" :isBotMessage="message.isBotMessage" />
            <ChatEmptyState v-if="!messages || messages.length === 0" />
        </div>
</template>

<script setup>
import { computed } from 'vue';
import { useConversationStore } from '../../store/conversation';
import ChatMessage from './ChatMessage.vue';
import ChatEmptyState from './ChatEmptyState.vue';
import ErrorMessage from './ErrorMessage.vue';
import { useWidgetStore } from '@/store/widget';

const conversationStore = useConversationStore();
const widgetStore = useWidgetStore();

const messages = computed(() => conversationStore.messages);
const answerSuggestions = computed(() => conversationStore.answerSuggestions);
const isThinking = computed(() => conversationStore.isThinking);
const tempMessage = computed(() => conversationStore.tempMessage);
const statusMessage = computed(() => conversationStore.statusMessage);
const name = computed(() => widgetStore.bot.name);
const avatarUrl = computed(() => widgetStore.bot.avatar_url);

const sendMessage = (message) => conversationStore.sendMessage(message);

</script>

<style>
.cierra-chat-option {
    @apply ctw-bg-inherit hover:ctw-bg-white/[.04]
            ctw-text-xs ctw-text-white/80
            ctw-py-2 ctw-px-4
            ctw-border ctw-border-solid ctw-border-white/30 ctw-rounded-full
            ctw-cursor-pointer
            ctw-transition-colors;
}
</style>